<template>
  <div
    class="card mb-3 stat-card-hover"
    :class="`border-left-${color}`"
  >
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start">
        <div class="flex-fill">
          <div class="text-muted text-uppercase small mb-2">
            <b>{{ label }}</b>
            <i
              v-if="tooltip"
              class="fa fa-info-circle ml-1"
              v-b-tooltip.hover.top="tooltip"
              style="cursor: help;"
            ></i>
          </div>
          <h2 v-if="hasValue" class="mb-0 font-weight-bold">
            {{ formattedValue }}
          </h2>
          <small v-if="!hasValue" class="mb-0 text-muted">
            No data available
          </small>
        </div>
        <div v-if="icon" :class="`text-${color}`" class="stat-icon-large">
          <i :class="`fa fa-${icon}`"></i>
        </div>
      </div>
      <div v-if="trend !== null" class="mt-2 small">
        <span :class="trendTextClass" class="font-weight-semibold">
          <i :class="trendIcon"></i>
          {{ Math.abs(trend) }}%
        </span>
        <span class="text-muted ml-1">vs yesterday</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      required: false,
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'success', 'warning', 'danger', 'info', 'secondary'].includes(value),
    },
    trend: {
      type: Number,
      default: null,
    },
    suffix: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasValue() {
      return this.value !== null && this.value !== undefined && this.value !== '';
    },
    formattedValue() {
      if (typeof this.value === 'number' && this.value % 1 !== 0) {
        return this.value.toFixed(1) + this.suffix;
      }
      return this.value + this.suffix;
    },
    trendTextClass() {
      if (this.trend > 0) return 'text-success';
      if (this.trend < 0) return 'text-danger';
      return 'text-secondary';
    },
    trendIcon() {
      if (this.trend > 0) return 'fa fa-arrow-up';
      if (this.trend < 0) return 'fa fa-arrow-down';
      return 'fa fa-minus';
    },
  },
};
</script>

<style lang="scss" scoped>
// Bootstrap color border utilities
.border-left-primary {
  border-left: 4px solid #007bff !important;
}
.border-left-success {
  border-left: 4px solid #28a745 !important;
}
.border-left-warning {
  border-left: 4px solid #ffc107 !important;
}
.border-left-danger {
  border-left: 4px solid #dc3545 !important;
}
.border-left-info {
  border-left: 4px solid #17a2b8 !important;
}
.border-left-secondary {
  border-left: 4px solid #6c757d !important;
}

// Hover effect
.stat-card-hover {
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
}

// Large icon with opacity
.stat-icon-large {
  font-size: 2.5rem;
  opacity: 0.2;
  margin-left: 1rem;
}


</style>
